import request from '../../../helpers/request';

const editCounterparty = async (counterparty) => {
  await request.put(
    `/RentPlace/counterparty`,
    {
      ...counterparty,
    },
    'Произошла ошибка при изменении контрагента'
  );
};

export default editCounterparty;
